const productStats = () => {
  if (document.body.classList.contains('product-product-26')) {
    return;
  }

  const statRings = document.querySelectorAll('.product-stats-item__ring');

  if (!statRings.length) {
    return;
  }

  const getTargetValue = (value) => {
    const normalizedValue = String(value ?? '')
      .replace(/[^\d.]/g, '')
      .trim();

    if (!normalizedValue) {
      return Number.NaN;
    }

    return Number.parseFloat(normalizedValue);
  };

  function animateProgress(ring) {
    const count = ring.parentElement.querySelector('.product-stats-item__percentage');
    const target = getTargetValue(ring.dataset.value || count?.textContent);

    if (!count || Number.isNaN(target)) {
      return;
    }

    let current = 0;
    const duration = 2000;
    const frameRate = 1000 / 60;
    const steps = duration / frameRate;
    const increment = target / steps;

    const animate = () => {
      current += increment;
      if (current >= target) current = target;

      count.textContent = Math.round(current);
      ring.style.background = `conic-gradient(#6d93c3 ${current}%, #000 0)`;

      if (current < target) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }

  const observer = new IntersectionObserver((entries, obs) => {
    let delay = 0;

    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        const ring = entry.target;

        setTimeout(() => {
          ring.classList.add('animate-in');
          animateProgress(ring);
        }, delay);

        delay += 500;

        obs.unobserve(ring); // run once per ring
      }
    });
  }, {
    threshold: 0.5
  });

  statRings.forEach(ring => {
    const count = ring.parentElement.querySelector('.product-stats-item__percentage');
    const target = getTargetValue(ring.dataset.value || count?.textContent);

    if (!Number.isNaN(target)) {
      ring.dataset.value = String(target);
    }

    observer.observe(ring);
  });

};

export default productStats;
